import { useQueryUser } from '@heidi/workspace/data';

const TRAINEE_SPECIALTY_GROUP = 'Trainee';

type Specialty = { id: string; group?: { name?: string } | null };

type UseSpecialties = (
  selector: (data: { specialties: Specialty[] }) => Specialty[],
  options: { enabled: boolean }
) => { data: Specialty[] | undefined };

export function useIsTraineeSpecialty(
  useQuerySpecialties: UseSpecialties,
  enabled = true
): boolean {
  const { data: specialtyId } = useQueryUser((user) => user.specialty_id);
  const { data: specialties } = useQuerySpecialties((data) => data.specialties, {
    enabled,
  });

  const userSpecialty = specialties?.find((specialty) => specialty.id === specialtyId);

  return userSpecialty?.group?.name === TRAINEE_SPECIALTY_GROUP;
}
